<template>
    <div
        class="w-full flex flex-col lg:flex-row items-start justify-center gap-6 lg:gap-10 px-4 lg:px-48 pb-5 lg:pb-10">
        <div class="bg-white rounded-xl shadow-md flex flex-col items-start text-gray-800 w-full">
            <p class="px-6 py-2 font-medium text-base text-white lg:text-lg bg-primary w-full mt-5 lg:mt-10">
                        Reminders (Safety and Security)</p>

            <div class="p-3 lg:p-6 w-full">
                <div class="rules-container text-gray-600 leading-relaxed mt-1 lg:mt-3 text-sm lg:text-base">
                <p class="mb-3">
                    For the safety and security of all participants, please adhere to the instructions and
                    reminders provided by event officials, including staff and volunteers. In relation, the
                    following items are strictly prohibited:
                </p>

                <ul class="list-disc pl-6 mb-4 space-y-1">
                    <li>Drugs</li>
                    <li>Alcoholic Beverages</li>
                    <li>Weapons, any sharp items, or potentially dangerous items such as hammers and knives</li>
                    <li>Firearms</li>
                    <li>Unmanned aerial devices, drones, survey balloons, photography mini-copters, and any flying
                        device with an on/off switch</li>
                </ul>

                <p class="mb-3">Please abide by the following guidelines and reminders:</p>

                <ul class="list-disc pl-6 space-y-1">
                    <li>Please refrain from engaging with solicitors or vendors of unofficial merchandise.</li>
                    <li>Parents and guardians are responsible for ensuring the safety of their children at all times.
                    </li>
                    <li>Please respect our no-smoking policy throughout the event.</li>
                    <li>Always adhere to directional signage and guidelines.</li>
                    <li>Please do not enter unauthorized areas.</li>
                    <li>
                        There will be no baggage deposit counters at the event. You are responsible for the safekeeping
                        of your own personal belongings. PAFCPIC will not be held liable for any loss or damage to
                        personal property or items.
                    </li>
                    <li>
                        Parking spaces are limited and available on a first-come, first-served basis. Monitor our
                        Facebook
                        page as we post the available parking sites inside and within the vicinity of the Philippine
                        Army
                        Grandstand.
                    </li>
                    <li>
                        Please use the marked entrances and exits for both pedestrians and vehicles. Use Gate 4 for the
                        ENTRANCE and Gate 3 for the EXIT. Both gates are located along Lawton Avenue across the
                        Land Bank branch.
                    </li>
                </ul>
            </div>


            <div class="w-full flex justify-end mt-10">
                <div class="w-full flex flex-row lg:w-1/3 space-x-3">
                    <ButtonControl ref="proceed" variant="secondary" @click="$router.back()">
                        BACK
                    </ButtonControl>
                    <ButtonControl ref="proceed" variant="primary" @click="$router.push('/confirm')">
                        NEXT
                    </ButtonControl>
                </div>
            </div>
            </div>
            

        </div>
    </div>

</template>

<script>
import ButtonControl from '@/components/controls/ButtonControl.vue';
import confirmLeave from "@/mixins/confirmLeave";

export default {
    name: "RemindersView",
    mixins: [confirmLeave],
    components: {
        ButtonControl,
    },
    data() {
        return {

        }
    },
    mounted() {
        if (!this.$store.state.form) {
            this.$router.push('/')
        }
    },
    methods: {

    },
};
</script>

<style scoped></style>
